module.exports = __webpack_public_path__ + "school/img/shipinpeixun3ji.b2b7ce1f.jpg";